import styled from "styled-components/macro";
import {device} from "../../styles";

export const Root = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 15px;
    
    ${device.less1180} {
        gap: 10px;
    }
`;

export const Item = styled.div`
    width: 45px;
    
    ${device.less1180} {
        width: 37px;
    }
`;
